import React from 'react';

import DialogBase from 'core/modules/components/dialogs/components/Dialog';
import MarkdownBase from 'core/modules/components/Markdown/Markdown';
import SelectCustomizableBase from 'core/modules/atoms/SelectCustomizable';
import TooltipCustomBase from 'core/modules/atoms/Tooltip/Tooltip';

type SelectOption = { label: string; value: string };

export const SelectCustomizable = SelectCustomizableBase as unknown as React.ComponentType<{
  closeMenuOnSelect?: boolean;
  components?: Record<string, React.ComponentType<any>>;
  isDisabled?: boolean;
  isLoading?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  label?: React.ReactNode;
  maxVisibleValues?: number;
  menuPosition?: 'absolute' | 'fixed';
  name?: string;
  onChange: (option: SelectOption | SelectOption[] | null) => void;
  options: SelectOption[];
  placeholder?: React.ReactNode;
  required?: boolean;
  size?: 'default' | 'small';
  value: SelectOption | SelectOption[] | null;
  variant?: 'default';
}>;

export const TooltipCustom = TooltipCustomBase as unknown as React.ComponentType<{
  aria?: 'describedby' | 'labelledby';
  arrow?: boolean;
  children: React.ReactElement;
  disabled?: boolean;
  placement?: string;
  title: React.ReactNode;
}>;

export const Dialog = DialogBase as unknown as React.ComponentType<{
  children?: React.ReactNode;
  className?: string;
  hideHeader?: boolean;
  onClose?: () => void;
  open: boolean;
  showHeader?: boolean;
  size?: 'default' | 'xxs' | 'xs' | 's' | 'small' | 'xl' | 'xxl' | 'all-screen';
  title?: React.ReactNode;
}>;

export const Markdown = MarkdownBase as unknown as React.ComponentType<{
  children: string;
  enableDebug?: boolean;
}>;
